










































































































































import { UibotInvoiceState } from "@/data/RPA";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import SettingsVue from "./Settings.vue";

@Component({
	...mapGetters(["accountBook"]),
	components: {
		SettingsVue
	},
})
export default class ImportZip extends Vue {
	@Prop({ type: String })
	invoiceName!: string;

	@Prop({ type: Boolean })
	importChange!: boolean;

	@Prop({ type: String })
	endPeriod!: string;

	@Prop({ type: [String, Number] })
	accountBookId!: string | number;

	isText: boolean = false

	tableData = [
		{
			name:"江苏",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"上海",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"宁波",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"河北",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"广东",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"深圳",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"福建",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"北京",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"江西",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"山东",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"天津",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"湖南",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"贵州",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"青岛",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"陕西",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"辽宁",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"山西",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		// {
		// 	name:"安徽",
		// 	area:"全国",
		// 	whether:"有",
		// 	scope:"全国",
		// 	not:"有",
		// },

		{
			name:"浙江",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"云南",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"湖北",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"安徽",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
		{
			name:"四川",
			area:"全国",
			whether:"有",
			scope:"全国",
			not:"有",
		},
	]

	url: string = "";
	file: any = {};
	param: any = {};
	arr: string[] = [];
	isContent: boolean = false;
	status = UibotInvoiceState[1];
	statusEnum = UibotInvoiceState;
	bookId = this.accountBookId ? this.accountBookId : this.$store.state.accountBook.id;
	result = {
		accountBookDto: null,
		accountBookId: null,
		accountId: null,
		areaId: null,
		endDate: null,
		gmtCreate: null,
		gmtModified: null,
		id: null,
		period: null,
		resultUrl: null,
		resultMessage: null,
		startDate: null,
		startTime: null,
		state: null,
	};

	async created() {
		this.getStatus();
	}

	async getStatus() {
		const res = await Vue.axios.get(
			`uibot/invoice/get?accountBookId=${this.bookId}&period=${this.endPeriod}`
		);
		this.status = UibotInvoiceState[res.data.state];
		this.result = res.data;
	}

	async importData() {
		const res = await Vue.axios.post("uibot/invoice/import", this.result, { headers: { accountBookId: this.accountBookId } });
		this.$alert(res.data.data, res.data.message)
	}

	setVisible = false;
	async saveInvoice() {
		this.$store.state.accountBook.id = this.bookId;
		this.setVisible = true;
	}
	closeSet(isFetch: boolean) {
		this.setVisible = false;
		if (isFetch) this.getStatus();
	}

	download() {
		this.$store.dispatch("toggleDownload", true);
		this.$utils.sendToElectron("download", this.result.resultUrl);
	}
	close() {
		this.$emit("close", true);
	}
}
